import {MITTWALD_API, Schemas} from "../middleware/MittwaldApi";
import * as ActionTypes from "../constants/ActionTypes";
import {queryBearerToken} from "./UserAuthentication";
import {getCartItems} from "../selectors/SimpleSelectors";
import {getMainArticleInCart} from "../selectors/Cart";

const fetchCustomerAccount = (bearer, accountNumber) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.ACCOUNTS_REQUEST, ActionTypes.ACCOUNTS_SUCCESS, ActionTypes.ACCOUNTS_FAILURE],
        endpoint: `accounts/${accountNumber}`,
        schema: Schemas.ACCOUNT,
        bearer: bearer,
        method: 'GET',
        postData: {}
    }
})


export const queryCustomerAccount = (accountNumber) => (dispatch, getState) => {
    return dispatch(queryBearerToken()).then(() => {
        return dispatch(fetchCustomerAccount(getState().token.bearer, accountNumber))
    })
}

const fetchCustomerAccounts = (bearer, customerNumber) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.ACCOUNTS_REQUEST, ActionTypes.ACCOUNTS_SUCCESS, ActionTypes.ACCOUNTS_FAILURE],
        endpoint: `customers/${customerNumber}/accounts`,
        schema: Schemas.ACCOUNTS,
        bearer: bearer,
        method: 'GET',
        postData: {}
    }
})


export const queryCustomerAccounts = (customerNumber) => (dispatch, getState) => {
    return dispatch(queryBearerToken()).then(() => {
        return dispatch(fetchCustomerAccounts(getState().token.bearer, customerNumber))
    })
}


const fetchPreUpgradeCheck = (bearer, accountIdentifier, targetArticleIdentifier) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.PRE_UPGRADECHECK_REQUEST, ActionTypes.PRE_UPGRADECHECK_SUCCESS, ActionTypes.PRE_UPGRADECHECK_FAILURE],
        endpoint: `orders/preUpgradeCheck/${accountIdentifier}/${targetArticleIdentifier}`,
        schema: Schemas.JSON,
        bearer: bearer,
        method: 'GET',
        postData: {}
    }
})

export const queryPreUpgradeCheck = () => (dispatch, getState) => {
    const productSelectionState = getState().productSelection;

    const mainArticle = getMainArticleInCart(getState());

    if(mainArticle && productSelectionState.selectedAccount) {
        return dispatch(queryBearerToken()).then(() => {
           return dispatch(fetchPreUpgradeCheck(getState().token.bearer, productSelectionState.selectedAccount, mainArticle));
        });
    }
}



/** WEBPACK FOOTER **
 ** ./src/actions/Accounts.js
 **/